__turbopack_context__.v({
  "categories": "BlogCard-module-scss-module__L4VsGW__categories",
  "cover": "BlogCard-module-scss-module__L4VsGW__cover",
  "dataWrapper": "BlogCard-module-scss-module__L4VsGW__dataWrapper",
  "excerpt": "BlogCard-module-scss-module__L4VsGW__excerpt",
  "image": "BlogCard-module-scss-module__L4VsGW__image",
  "link": "BlogCard-module-scss-module__L4VsGW__link",
  "metaSeparator": "BlogCard-module-scss-module__L4VsGW__metaSeparator",
  "tag": "BlogCard-module-scss-module__L4VsGW__tag",
  "title": "BlogCard-module-scss-module__L4VsGW__title",
  "wrapper": "BlogCard-module-scss-module__L4VsGW__wrapper",
});
